export const LOAD_ASSET_LABELS = 'assetLabels/LOAD_ASSET_LABELS';
export const LOAD_SUGGESTED_ASSET_LABELS = 'assetLabels/LOAD_SUGGESTED_ASSET_LABELS';
export const ADD_LABEL_TO_ASSET = 'assetLabels/ADD_LABEL_TO_ASSET';
export const REMOVE_LABEL_FROM_ASSET = 'assetLabels/REMOVE_LABEL_FROM_ASSET';
